export default __webpack_public_path__ + "static/media/IMG_HOME_EMPRESAS.d2548aa3.png";